import React, { createContext, useContext, useState, useRef, useCallback } from 'react';

/**
 * Contexto global - usa ref para evitar re-renders e problemas de timing.
 * - hasUnsavedSale: setado pelo PDV via setHasUnsavedSale
 * - requestNavigation: chamado pela Sidebar. Se NÃO há venda em aberto,
 *   executa o proceed imediatamente. Se há, dispara o handler do PDV.
 */
const PDVContext = createContext(null);

export const PDVProvider = ({ children }) => {
  const hasUnsavedRef = useRef(false);
  const blockHandlerRef = useRef(null);
  const [, force] = useState(0); // só para forçar re-render quando útil

  const setHasUnsavedSale = useCallback((v) => {
    hasUnsavedRef.current = !!v;
    // exposed para debug
    if (typeof window !== 'undefined') window.__hasUnsavedSale = !!v;
  }, []);

  const registerBlockHandler = useCallback((fn) => {
    blockHandlerRef.current = fn;
  }, []);

  const unregisterBlockHandler = useCallback(() => {
    blockHandlerRef.current = null;
  }, []);

  const requestNavigation = useCallback((proceed) => {
    if (hasUnsavedRef.current && blockHandlerRef.current) {
      blockHandlerRef.current(proceed);
      return false;
    }
    proceed();
    return true;
  }, []);

  return (
    <PDVContext.Provider value={{
      setHasUnsavedSale,
      registerBlockHandler,
      unregisterBlockHandler,
      requestNavigation,
    }}>
      {children}
    </PDVContext.Provider>
  );
};

export const usePDVContext = () => {
  const ctx = useContext(PDVContext);
  if (!ctx) throw new Error('usePDVContext deve estar dentro de PDVProvider');
  return ctx;
};
